import React from 'react'

import type { CategoryGridContentBlock } from '@library/api-menu-experience'
import { CategoryGrid } from '@library/menu-page'

type CategoryGridContentBlockWrapperProps = {
  contentBlock: CategoryGridContentBlock
}

const onCategoryClick = () => {}

export const CategoryGridContentBlockWrapper = ({
  contentBlock,
}: CategoryGridContentBlockWrapperProps) => (
  <CategoryGrid contentBlock={contentBlock} onCategoryClick={onCategoryClick} />
)
